module.exports = __webpack_public_path__ + "static/media/IMG_0082.0ac50597.jpg";